jQuery(document).ready(function ($) {
  var $ = jQuery;
  $('.slick-carousel-fade').slick({
    dots: true,
    prevArrow: false,
    nextArrow: false,
    infinite: true,
    speed: 1000,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 5000
  });
  $('.slick-carousel-gallery').slick({
    dots: false,
    prevArrow: false,
    nextArrow: false,
    infinite: true,
    speed: 1000,
    fade: true,
    cssEase: 'linear',
    draggable: false,
    autoplay: true,
    autoplaySpeed: 5000
  });
  $('.slick-carousel-gallery').on('afterChange', function() {
    var dataId = $(this).find('.slick-current').attr("data-slick-index");
    var id = $(this).attr('id');
    $('.dots[data-slider="'+id+'"] .dot').removeClass('active');
    $('.dots[data-slider="'+id+'"] .dot[data-id="'+dataId+'"]').addClass('active');
  });

  $(".dots .dot").click(function(e){
    e.preventDefault();
    var slideIndex = $(this).data("id");
    var slideID = $(this).parent().data("slider");
    $( '#'+slideID ).slick('slickGoTo',  parseInt(slideIndex));
  });


    AOS.init({
      once: true,
      disable: 'mobile'
    });
  $('body').on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('#menuMobile').removeClass('active');
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 1000);
  });
  $('body').on('click', '.js-bottom-click', function (event) {
    event.preventDefault();
    var id = '#'+$(this).parent().next().attr('id');
    $('html, body').animate({
      scrollTop: $(id).offset().top
    }, 1000);
  });

  $('body').on('click', '.js-click-hamburger', function (event) {
    $('#menuMobile').toggleClass('active');
  });
  $('body').on('click', '.js-close-menu', function (event) {
    $('#menuMobile').toggleClass('active');
  });

});